import decode from 'jwt-decode';
import axios from "axios";
import { CLIENT_NAME_MAP } from './constants';
import { getServiceApiKey, setServiceApiKey } from './apiKey';
import { isAccessTokenValid, isRefreshTokenValid, removeUserTokens, removeUserPreferences, logout } from './user';
const BASE_API_URL = `${window?.appConfig?.API_ENDPOINT}`;


// Authentication utility function
const authUtil = {

    //TODO: update based on actual response
    //set the token in local storage
    setSession: (response) => {
    try {
        if (!response || typeof response !== 'object') {
            throw new Error("Invalid response object.");
        }

        const data = response.data;
        if (!data || typeof data !== 'object') {
            throw new Error("Invalid response data.");
        }

        const { token, clientName } = data;
        if (!token || typeof token !== 'string') {
            throw new Error("Invalid or missing token in response data.");
        }

        if (!clientName || typeof clientName !== 'string') {
            throw new Error("Invalid or missing clientName in response data.");
        }

        const decoded = decode(token);
        if (!decoded || typeof decoded.exp !== 'number') {
            throw new Error("Invalid or missing token expiry time.");
        }

        // Save validated data to localStorage
        localStorage.setItem('_documentServiceToken', token);
        localStorage.setItem('_clientName', clientName);
        localStorage.setItem('_documentServiceTokenExpiry', decoded.exp);

    } catch (error) {
        console.error("Error setting session:", error.message);
        throw error;
    }
}
,

    updateToken: (newToken) => {
        if (authUtil.isAuthenticated()) {
            const decoded = decode(newToken);
            localStorage.setItem('_documentServiceToken', newToken);
            localStorage.setItem('_documentServiceTokenExpiry', decoded.exp);
        }
    },

    //get token utlity
    getDocumentServiceToken: async () => {
        try {
            const token = localStorage.getItem('_documentServiceToken');
            if (token === null || token === undefined) {
                const documentServiceIntegrationtoken = await authUtil.generateToken();
                authUtil.setSession(documentServiceIntegrationtoken);
                return documentServiceIntegrationtoken.data.token;
            } else {
                if(authUtil.isTokenExpired()) {// If integration token is expired
                    // check for access token and refresh token
                    if(isAccessTokenValid() || isRefreshTokenValid()) {
                        // If true, regenerate it
                        const documentServiceIntegrationtoken = await authUtil.generateToken();
                        authUtil.setSession(documentServiceIntegrationtoken);
                        return documentServiceIntegrationtoken.data.token;
                    }
                    else {
                        // If false, clear tokens and redirect to login
                        removeUserTokens();
                        removeUserPreferences();
                        window.location.href = `${window.location.origin}/login`;
                    }
                }
                else{
                    return token;
                }
            }
        } catch (error) {
            throw error;
        }
        
    },

    generateToken: async(client = null, email = null) => {
        if(!client) {
            client = localStorage.getItem('_clientName');
        }
        else {
            if(CLIENT_NAME_MAP[client]) {
                client = CLIENT_NAME_MAP[client];
              }
        }

        if(!email) {    
            email = localStorage.getItem('userEmail'); 
        }

        const requestObj = JSON.stringify({
            clientId: client,
            userEmail: email
        });
        const response =  axios.post(BASE_API_URL + '/token', requestObj, {
            headers: {
                "Content-Type": "application/json",
                "x-api-key": getServiceApiKey(),
            }
        });

        return response;
    },

    getClientInfo: () => {
        if (authUtil.isAuthenticated()) {
            const decoded = decode(localStorage.getItem('_documentServiceToken'));
            localStorage.setItem('_clientName', decoded.user_obj.clientName)
            return decoded.user_obj.clientName;
        } else {
            return '';
        }
    },
    //check if token is expired or not
    isTokenExpired: () => {
        try {
            const expiry = localStorage.getItem('_documentServiceTokenExpiry');
            if (expiry < Date.now() / 1000) { // Checking if token is expired.
                return true;
            }
            else {
                return false;
            }
        }
        catch (err) {
            return false;
        }
    },

    // checks if the user is authenticated
    isAuthenticated: () => {
        const token = localStorage.getItem('_documentServiceToken');
        if (token === null || token === undefined) {
            return false;
        } else {
            if(authUtil.isTokenExpired()) {// If integration token is expired
                // check for access token and refresh token
                if(isAccessTokenValid() || isRefreshTokenValid()) {
                    // If true, regenerate it
                }
                else {
                    // If false, clear tokens and redirect to login
                    removeUserTokens();
                    removeUserPreferences();
                    window.location.href = `${window.location.origin}/login`;
                }
            }
            else{
                return true;
            }
        }
    },

    // Clears session data but preserves the service API key (only returned on SSO login, not refresh).
    clearSession: () => {
        const apiKey = getServiceApiKey();
        localStorage.clear();
        if (apiKey) {
            setServiceApiKey(apiKey);
        }
    },

    logout,
};
export default authUtil;
